<template>
    <div v-if="loading" class="loading">
        <img src="/img/loading.gif"/>
    </div>
</template>

<script>

    import { mapGetters } from 'vuex'
    import * as getter from '../store/types/getters'

    export default {
        name: 'loading-view',

        data: () => ({
        }),

        props: {
            //loading: false
        },

        computed: {
            ...mapGetters({
                loading: [getter.LOADING]
            })
        },

        mounted () {
        }
    }

</script>

<style lang="scss" scoped>
    .loading {
        width: 100%;
        height: 100%;
        background-repeat: no-repeat;
        background-size: contain;
        background-position: center;
        position: fixed;
        top: 0;
        left: 0;
        background-color: #403f3f;
        z-index: 9999;
        opacity: 0.8;

        img {
            position: absolute;
            top: 0;
            bottom: 0;
            right: 0;
            left: 0;
            margin: auto;
            width: 40px;
            @media screen and (max-width:575px) {
                width: 20vw;
            }
        }
    }
</style>



// WEBPACK FOOTER //
// resources/assets/js/components/LoadingView.vue